/**
 * Formats a timestamp into a human-readable date and time string.
 * @param {number} timestamp - The timestamp to format.
 * @returns {string} A string representing the formatted date and time.
 */
export const formatTimestamp = (timestamp, locale = 'en-US') => {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    }
    const date = new Date(timestamp * 1000);
    return date.toLocaleString(locale, options);
};